import { render, staticRenderFns } from "./BatchOperationReview.vue?vue&type=template&id=375cbc5d&scoped=true&"
import script from "./BatchOperationReview.vue?vue&type=script&lang=js&"
export * from "./BatchOperationReview.vue?vue&type=script&lang=js&"
import style0 from "./BatchOperationReview.vue?vue&type=style&index=0&id=375cbc5d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "375cbc5d",
  null
  
)

export default component.exports